import apiClient from "@/services/api-client";
import { useQuery } from "@tanstack/react-query";
import { errorLogger } from "@/utils/helpers/logger";

const fetchSearchData = (url) => {
  return apiClient({
    method: "get",
    url: `/v1${url}`,
  });
};

const fetchSortOptions = () => {
  return apiClient({
    method: "get",
    url: `/v1/products/sortable`,
  });
};

export const useFetchSearchData = (url, useQueryOptions) => {
  return useQuery({
    queryKey: ["search", url],
    queryFn: () => fetchSearchData(url),
    ...useQueryOptions,
    keepPreviousData: true,
    select: (data) => {
      let apiData = data.data?.data;
      return apiData;
    },
    onError: (error) => {
      errorLogger.logApiError(error);
    },
  });
};

export const useFetchSortOptions = (useQueryOptions) => {
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};
  return useQuery({
    queryKey: ["sortOptions"],
    queryFn: fetchSortOptions,
    onSuccess,
    select: (data) => {
      let apiData = data.data?.data;
      return apiData?.sortables;
    },
    onError: (error) => {
      errorLogger.logApiError(error);
      onError(error);
    },
  });
};
